import { useState, useRef, useEffect } from 'react';
import { Navigation, X } from 'lucide-react';

export function NavigationModal({ loja, onClose }) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  if (!loja || !loja.lat || !loja.lng) return null;

  const openGoogleMaps = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${loja.lat},${loja.lng}`;
    window.open(url, '_blank');
    onClose();
  };

  const openWaze = () => {
    const url = `https://waze.com/ul?ll=${loja.lat},${loja.lng}&navigate=yes`;
    window.open(url, '_blank');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div 
        ref={modalRef}
        className="bg-[var(--bg-card)] rounded-xl p-5 shadow-xl max-w-sm w-full border border-[var(--border-color)]"
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-[var(--text-primary)] flex items-center gap-2">
            <Navigation size={20} className="text-[var(--accent-primary)]" />
            Navegar para
          </h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-[var(--bg-chip)] rounded-full transition-colors"
          >
            <X size={20} className="text-[var(--text-muted)]" />
          </button>
        </div>
        
        <p className="text-sm text-[var(--text-secondary)] mb-4 truncate">
          {loja.name}
        </p>

        <div className="flex flex-col gap-3">
          {/* Google Maps */}
          <button
            data-testid="btn-open-google-maps"
            onClick={openGoogleMaps}
            className="w-full p-4 rounded-lg bg-[#4285F4] hover:bg-[#3367D6] text-white flex items-center gap-3 transition-colors"
          >
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="#4285F4" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                <circle fill="#EA4335" cx="12" cy="9" r="2.5"/>
              </svg>
            </div>
            <div className="text-left">
              <div className="font-semibold">Google Maps</div>
              <div className="text-xs opacity-80">Abrir rota no Google Maps</div>
            </div>
          </button>

          {/* Waze */}
          <button
            data-testid="btn-open-waze"
            onClick={openWaze}
            className="w-full p-4 rounded-lg bg-[#33CCFF] hover:bg-[#00B8E6] text-white flex items-center gap-3 transition-colors"
          >
            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="#33CCFF" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                <circle fill="#33CCFF" cx="8" cy="10" r="1.5"/>
                <circle fill="#33CCFF" cx="16" cy="10" r="1.5"/>
                <path fill="#33CCFF" d="M12 17c-2.33 0-4.32-1.45-5.12-3.5h1.67c.69 1.19 1.97 2 3.45 2s2.76-.81 3.45-2h1.67c-.8 2.05-2.79 3.5-5.12 3.5z"/>
              </svg>
            </div>
            <div className="text-left">
              <div className="font-semibold">Waze</div>
              <div className="text-xs opacity-80">Abrir rota no Waze</div>
            </div>
          </button>
        </div>

        <button
          onClick={onClose}
          className="w-full mt-4 p-2 text-[var(--text-muted)] text-sm hover:text-[var(--text-primary)] transition-colors"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
